import React from 'react'
import styled from '@emotion/styled'
import { colors } from '../tokens/colors'

export type IconProps = {
  size?: 'large' | 'small'
  variant?: 'outlined' | 'filled'
  color?: string
}

type ContainerProps = {
  size: IconProps['size']
  variant: IconProps['variant']
  color: IconProps['color']
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${(props) => (props.size === 'large' ? '24px' : '20px')};
  height: ${(props) => (props.size === 'large' ? '24px' : '20px')};

  svg {
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 100ms ease-in;
    fill: ${(props) => props.color};
  }

  svg:first-of-type {
    opacity: ${(props) => (props.variant === 'outlined' ? '1' : '0')};
  }

  svg:nth-of-type(2) {
    opacity: ${(props) => (props.variant === 'outlined' ? '0' : '1')};
  }
`

export const createIconComponent = ({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
}: {
  OutlinedLarge: React.FC
  OutlinedSmall: React.FC
  FilledLarge: React.FC
  FilledSmall: React.FC
}) => {
  return ({
    size = 'large',
    variant = 'outlined',
    color = colors.illustration.darkBlue,
  }: IconProps) => {
    const Outlined = size === 'large' ? OutlinedLarge : OutlinedSmall
    const Filled = size === 'large' ? FilledLarge : FilledSmall

    return (
      <Container size={size} variant={variant} color={color}>
        <Outlined />
        <Filled />
      </Container>
    )
  }
}
export type Icon = ReturnType<typeof createIconComponent>
